import React from 'react';
import { Route } from 'react-router-dom';
import { RequireGroup } from './RequireGroup';
import { AdminLayout } from './AdminLayout';
import { AdminDashboard } from './AdminDashboard';
import { AuditLogPage } from './AuditLogPage';
import { UserRolesPage } from './UserRolesPage';
import { EditionsPage } from './prices/EditionsPage';
import { CatalogPage } from './catalog/CatalogPage';
import { ImportPage } from './catalog/ImportPage';
import { AccountExecsPage } from './accountExecs/AccountExecsPage';

/**
 * The /admin route subtree. A function, not a component — react-router's
 * <Routes> requires its element children to literally be <Route> (or
 * <React.Fragment>) elements, so this is called inline as `{adminRoutes(user)}`
 * rather than rendered as `<AdminRoutes user={user} />`. Shared between the
 * shipped App routes (src/App.js) and AdminLayout.test.jsx so the tests bind
 * to the real wiring instead of a hand-built copy of it.
 */
export function adminRoutes(user) {
  return (
    <Route
      path="/admin"
      element={(
        <RequireGroup user={user} anyOf={['adminAccess', 'catalogAuthor']}>
          <AdminLayout user={user} />
        </RequireGroup>
      )}
    >
      <Route index element={<AdminDashboard user={user} />} />
      <Route path="audit" element={(
        <RequireGroup user={user} anyOf={['adminAccess']}>
          <AuditLogPage />
        </RequireGroup>
      )} />
      <Route path="users" element={(
        <RequireGroup user={user} anyOf={['adminAccess']}>
          <UserRolesPage />
        </RequireGroup>
      )} />
      <Route path="account-execs" element={(
        <RequireGroup user={user} anyOf={['adminAccess']}>
          <AccountExecsPage user={user} />
        </RequireGroup>
      )} />
      <Route path="prices" element={(
        <RequireGroup user={user} anyOf={['adminAccess', 'catalogAuthor']}>
          <EditionsPage user={user} />
        </RequireGroup>
      )} />
      <Route path="catalog" element={(
        <RequireGroup user={user} anyOf={['catalogAuthor']}>
          <CatalogPage vendor="AIC" user={user} />
        </RequireGroup>
      )} />
      <Route path="catalog/import" element={(
        <RequireGroup user={user} anyOf={['catalogAuthor']}>
          <ImportPage vendor="AIC" user={user} />
        </RequireGroup>
      )} />
    </Route>
  );
}

export default adminRoutes;
